export function buildPreviewEntityExecutionRequest({
  preview,
  promptText,
  files = [],
  input = {},
}) {
  const entity = preview?.selected_entity || {};
  if (!entity?.type || entity.type === "agent") {
    return null;
  }
  return {
    intent: String(promptText || "").trim(),
    entity_type: entity.type,
    entity_id: entity.id,
    entity_version: entity.version,
    action: entity.action,
    files: Array.isArray(files) && files.length ? files : undefined,
    input: {
      ...(input || {}),
      intent: String(promptText || "").trim(),
    },
    preview_id: preview?.preview_id,
    preview_token: preview?.confirmation_token || preview?.preview_token,
    preview_decision: preview?.decision,
    confirmed_execution_type: preview?.execution_type || preview?.mode,
  };
}
